import React from 'react'
import { Route, Routes } from 'react-router-dom'
// pages
import BestOnlineComp from '../Components/BestOnlineComp/BestOnlineComp'
// Tools
import SiteMap from '../Tools/SiteMap/SiteMap'
import NotFound from '../Tools/NotFound/NotFound'
import PrivacyPolicy from '../Components/PrivacyPolicy/PrivacyPolicy'
import TermOfUse from '../Components/TermOfUse/TermOfUse'


export default function Main({ BestOnline, UserSession,Companies, ShowAllCompanies, setShowAllCompanies, CategoryInfo, CitiesData, ZipCode, setZipCode, ServicesData, setUpdateApp, ProjectList, setProjectList, showsetNotification, showsetNotificationType, navigateTo, CarPath, Blogs, Inventory, MakersArray, CitiesArray, WebSitePages }) {

    return (
        <div>
            <Routes>
                {/* Pages */}
                <Route path="/" element={<BestOnlineComp BestOnline={BestOnline} UserSession={UserSession} CitiesData={CitiesData} ZipCode={ZipCode} setZipCode={setZipCode} ServicesData={ServicesData} ProjectList={ProjectList} setUpdateApp={setUpdateApp} navigateTo={navigateTo} />} />
]
                <Route path="/health/best-weight-loss" element={<BestOnlineComp BestOnline={BestOnline} ShowAllCompanies={ShowAllCompanies} setShowAllCompanies={setShowAllCompanies} CategoryInfo={CategoryInfo} CitiesData={CitiesData} Companies={Companies} ServicesData={ServicesData} ProjectList={ProjectList} setProjectList={setProjectList} navigateTo={navigateTo} />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermOfUse />} />

                {/* SiteMap */}
                {["/sitemaps", "/sitemap", "/widgets"].map((path, index) =>
                    <Route path={path} key={index} element={<SiteMap CarPath={CarPath} Inventory={Inventory} MakersArray={MakersArray} Blogs={Blogs} WebSitePages={WebSitePages} />} />
                )}
                <Route path="*" element={<NotFound />} />
                <Route path="/sitemap/:id" element={<SiteMap CitiesArray={CitiesArray} CarPath={CarPath} Inventory={Inventory} MakersArray={MakersArray} Blogs={Blogs} WebSitePages={WebSitePages} />} />

            </Routes>
        </div>
    )
}
